import React from 'react';
import { styled, createGlobalStyle } from 'styled-components';
import { Indicator } from './Indicator';
import { Colors, hexWithOpacity } from '../../../../play-core/styles/Colors';
import { Device } from '../../../../play-core/styles/Device';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
export const Wrapper = styled.div.withConfig({
  displayName: "Sliderstyles__Wrapper",
  componentId: "sc-1dzer7i-0"
})([""]);
export const Slide = styled.div.withConfig({
  displayName: "Sliderstyles__Slide",
  componentId: "sc-1dzer7i-1"
})(["will-change:opacity;pointer-events:", ";transform:", ";"], ({
  currentIndex,
  index
}) => currentIndex === index ? 'auto' : 'none', ({
  index
}) => `translateX(-${100 * index}%)`);
export const Slides = styled.div.withConfig({
  displayName: "Sliderstyles__Slides",
  componentId: "sc-1dzer7i-2"
})(["display:grid;grid-auto-flow:column;grid-auto-columns:100%;&.shifting{", "{transition:opacity 0.3s ease-in-out;}}"], Slide);
export const horizontalMargin = 24;
export const Navigation = styled.div.withConfig({
  displayName: "Sliderstyles__Navigation",
  componentId: "sc-1dzer7i-3"
})(["display:flex;justify-content:space-between;align-items:center;position:absolute;pointer-events:none;height:100%;bottom:0;z-index:10;width:calc(100% - ", "px);left:50%;transform:translate(-50%,0);", "{display:none;}", "{max-width:1874px;}"], horizontalMargin * 2, Device.touch, Viewports.for('xLargeUp'));
export const buttonSize = 62;
export const NavigationButton = styled(props => /*#__PURE__*/_jsx("button", {
  ...props,
  tabIndex: -1
})).withConfig({
  displayName: "Sliderstyles__NavigationButton",
  componentId: "sc-1dzer7i-4"
})(["pointer-events:all;display:flex;align-items:center;justify-content:center;cursor:pointer;background-color:", ";color:", ";width:", "px;height:", "px;border-radius:50%;transition:all 0.2s ease-in-out;opacity:0;", ":hover &{opacity:1;}&:hover{background-color:", ";}"], hexWithOpacity(Colors.WHITE, 20), Colors.WHITE, buttonSize, buttonSize, Wrapper, hexWithOpacity(Colors.RED_8b0019, 100));
export const GlobalSliderStyles = createGlobalStyle(["body{overscroll-behavior:none;overscroll-behavior-y:auto;}"]);
export const StyledIndicator = styled(Indicator).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "Sliderstyles__StyledIndicator",
  componentId: "sc-1dzer7i-5"
})(["position:absolute;bottom:24px;left:50%;transform:translateX(-50%);"]);
export const getSlideProgress = (index, sliderProgress, numberOfSlides) => {
  const lastIndex = numberOfSlides - 1;
  let progress = 1 - Math.abs(sliderProgress - index);
  // Case when dragging over the last slide, the first slide should fade in again
  if (sliderProgress > lastIndex && index === 0) {
    progress = 1 - (numberOfSlides - sliderProgress);
  }
  // Case when dragging before the first slide, the last slide should fade in again
  if (sliderProgress < 0 && index === lastIndex) {
    progress = Math.abs(sliderProgress);
  }
  // Clamp value between 0 and 1
  return Math.max(0, Math.min(1, progress));
};